import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetPurchaseBase, PurchaseRequestBO, VendorBO } from './purchase-request.model';
import { BulkT2025UpdateBO, MultipleAccecpt_RejectBO } from '../evvtimesheet/evvtimesheet.model';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PurchaseRequestService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }


getClientDropdown(): Observable<any> {
  let url = "api/Client/GetClientDropDown?";
  return this.http.get<any>(url , { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

savePurchaseRequest(Bo: PurchaseRequestBO[]):Observable<any>{
  let url="api/PurchaseRequest/SaveMultiplePurchases";
  return this.http.post<any>(url,Bo,{observe:'response'}).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
UpdatePurchaseRequest(Bo:FormData):Observable<any>{
  let url="api/PurchaseRequest/SavePurchaseRequest";
  return this.http.post<any>(url,Bo,{observe:'response'}).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}

GetAuthForPurchaseRequest(params:URLSearchParams):Observable<any>{
  let url="api/PurchaseRequest/GetAuthForPurchase?";
  return this.http.get(url+params , { observe: 'response',responseType: "text"},).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
getLov(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Lov/GetLovDropDown?";
  return this.http.get(url + paramsData, { observe: 'response',responseType: "text"},).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}



getVendorList(): Observable<any> {
  let url = "api/Vendor/GetVendorListDD?";
  return this.http.get(url , { observe: 'response',responseType: "text"},).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}


AcceptPurchaseRequest(params:URLSearchParams):Observable<any> {
  let url="api/PurchaseRequest/AcceptStatusUpdate?";
  return this.http.get(url+params, { observe: 'response',responseType: "text"},).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
  )
}

RejectPurchaseRequest(params:URLSearchParams):Observable<any> {
  let url="api/PurchaseRequest/RejectStatusUpdate?";
  return this.http.get(url+params, { observe: 'response',responseType: "text"},).pipe(
    map(data=>data.body),
    catchError(this.errorService.handleError)

  )
}

///
AcceptAfterError(params:URLSearchParams):Observable<any> {
  let url="api/PurchaseRequest/ReduceAmount?";
  return this.http.get(url+params, { observe: 'response',responseType: "text"},).pipe(
    map(data=>data.body),
    catchError(this.errorService.handleError)
  )
}

saveupdateVendor(saveList: VendorBO): Observable<any> {

  let url = "api/Vendor/SaveVendor";
  return this.http.post(url, saveList, { observe: 'response',responseType: "text"}).pipe(
     map(data => data.body),
     catchError(this.errorService.handleError)
  )
} 

   //==============================get employee permission==========================================//
   getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  exportcsv(getBO: GetPurchaseBase): Observable<any> {

    let url = "api/PurchaseRequest/ExportPurchaseRequests";

    return this.http.post(url, getBO, { observe: 'response' }).pipe(

      map(data => data.body),
      catchError(this.errorService.handleError))


  }
  updateMulitplePurchases(getBO: BulkT2025UpdateBO): Observable<any> {
    let url = "api/PurchaseRequest/BulkPurchaseRequestUpdate";
    return this.http.post(url, getBO, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  
  
  }
  getAcitveAuths(paramsData: URLSearchParams): Observable<any> {
    let url = "api/TransactionMenu/getActiveAuthsWithinDateRange?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetServiceDropdownBasedonAuthType(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Service/GetServiceDropdownBasedonAuthType?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
  }


  getBase64Purchase(paramsData: URLSearchParams): Observable<any> {
    let url = "api/PurchaseRequest/GetSinglePurchaseDoc?";
    return this.http.get(url + paramsData, { observe: 'response',responseType: "text"},).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  updateMulitpleAccept_sts(multiacceptBO: MultipleAccecpt_RejectBO[]): Observable<any> {
    let url = "api/PurchaseRequest/MultipleAccecptReject";
    return this.http.post(url, multiacceptBO, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))   
  }
 
  AcceptAfterMultipleError(multiacceptBO: MultipleAccecpt_RejectBO[]):Observable<any> {
    let url = "api/PurchaseRequest/MultipleReduceAmount";
    return this.http.post(url, multiacceptBO, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))  
  }
}
